import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Maybe from 'react-maybe';

const isToday = (date) => {
    const today = new Date();
    return date.getDate() === today.getDate()
      && date.getMonth() === today.getMonth()
      && date.getFullYear() === today.getFullYear();
};

const FormatDate = ({ date }) => (
    <Maybe
        of={isToday(date)}
        either="dzisiaj"
        orElse={moment(date).format('DD MMMM')}
    />
);
FormatDate.propTypes = {
    date: PropTypes.instanceOf(Date).isRequired
};

export default FormatDate;